const PauseIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon" clipPath="url(#clip0_15_247)">
        <path
          id="circle-pause"
          d="M8.125 6.25C7.78125 6.25 7.5 6.53125 7.5 6.875V13.125C7.5 13.4688 7.78125 13.75 8.125 13.75C8.46875 13.75 8.75 13.4688 8.75 13.125V6.875C8.75 6.53125 8.46875 6.25 8.125 6.25ZM11.875 6.25C11.5312 6.25 11.25 6.53125 11.25 6.875V13.125C11.25 13.4705 11.5295 13.75 11.875 13.75C12.2205 13.75 12.5 13.4705 12.5 13.125V6.875C12.5 6.53125 12.2188 6.25 11.875 6.25ZM10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 18.75C5.17578 18.75 1.25 14.8242 1.25 10C1.25 5.17578 5.17578 1.25 10 1.25C14.8242 1.25 18.75 5.17578 18.75 10C18.75 14.8242 14.8242 18.75 10 18.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_247">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PauseIcon;
